module.exports = (elm) ->

  initializeHandler = (cmdHandler) ->
    commands = ['form-ready']
    h = {}
    commands.forEach (cmd) ->
      if cmdHandler? && cmdHandler[cmd]?
        h[cmd] = cmdHandler[cmd]
      else
        h[cmd] = ->
          # Blank function. If the calling code has not provided a function
          # to handle this command, we will execute an empty function instead.
    h

  handleCmd = (cmdHandler, opts) ->
    cmd = opts[0]
    data = opts[1]
    app = this

    cmdHandler[cmd].bind(app, data).call()

  initialize_signatures = (cmdHandler) ->
    $('.signature_pad_app:empty').each ->
      el = $(this)
      opts = el.data()
      opts.pointerEvent = window.PointerEvent?
      app = elm.Signature.embed(el.get()[0], el.data())
      if cmdHandler?
        initializedHandler = initializeHandler(cmdHandler)
        app.ports.signature_pad_command.subscribe(
          handleCmd.bind(app, initializedHandler)
        )

      app.cp_jq = el

  $ ->
    initialize_signatures()

  {
    initialize_signatures: initialize_signatures
  }
